import atigoghana from './airteltigo-money-logo.png'
import mtnghana from './mtn-money-logo.png'
import vodaghana from './telecel-money-logo.jpg'

export {
  atigoghana,
  mtnghana,
  vodaghana
}
